import React from 'react';
import PropTypes from 'prop-types';

const VideoObject = ({ schema, id }) => (
	<script
		type='application/ld+json'
		dangerouslySetInnerHTML={{
			__html: `{
				"@context": "https://schema.org",
				"@type": "VideoObject",
				"name": "${schema.heading}",
				"description": "${schema.description?.replace(/"/g, "'") || ''}",
				"thumbnailUrl": [
					"https://img.youtube.com/vi/${id}/0.jpg",
					"https://img.youtube.com/vi/${id}/1.jpg",
					"https://img.youtube.com/vi/${id}/2.jpg"
				],
				"uploadDate": "${schema.upload_date}",
				"duration": "${schema.duration}",
				"embedUrl": "https://www.youtube.com/embed/${id}"
			}`,
		}}
	/>
);

VideoObject.propTypes = {
	schema: PropTypes.object,
	id: PropTypes.string,
};

export default VideoObject;
